export default __webpack_public_path__ + "static/media/advMarina.66777428.jpg";